/**
 * 앱단으로 이벤트를 보내는 경우 활용합니다.
 */

import TagManager from 'react-gtm-module'
// app 에서 이벤트를 처리하기 위한 목적입니다.

export function sendToAppAnalyticsEvent(args: TagManager.DataLayerArgs) {
  window.ReactNativeWebView?.postMessage(
    JSON.stringify({
      type: 'app_analytics',
      data: args.dataLayer,
    })
  )
}
